

import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import { merchSignin, merchBaseSetting } from "../api/net/loginApi";
import { IWindowOptions, EventType } from "../types/base/IWindowOptions";
import options from "../config/transition-router";
import {
  IStateUserInfo,
  ILoginMerchant
} from "../types/interface/User/UserTypes";
import { startSignalR } from "../api/signalR";
import { getUserRatingForOrder } from "../api/net/order";
import {
  GetTotalUnReadCountRequest,
  CommunicationParty
} from "../types/interface/IM/IMTypes";
import { getUnreadMessageCount } from "../api/net/im";
import {
  event,
  os,
  parseQueryToObject,
  commitTokenExpireTimeToVuex,
  getOrderStatusForRequestOrderList
} from "../libs/utils";
import { cleanStatusAndTimerForLogout, sendEvent } from "../libs/utils";
import { IOrderPayload, IOrderPaging } from "../types/interface/IOrderDto";
import { IOrderStatusForRequestOrderList } from "../types/interface/IOrderDto";
import { OrderTab, OrderStatus } from "../types/enum/OrderEnum";

@Component({
  name: "BaseApp"
})
export default class BaseApp extends Vue {
  merchants: Array<ILoginMerchant> = [];

  connectionRetryCount: number = 0;
  maxSignalRRetryCount: number = 5;
  useSignalR: boolean = false;

  @Getter("options") options!: IWindowOptions;
  @Getter("merchId") merchId!: string;
  @Getter("merchIds") merchIds!: Array<string>;
  @Getter("userInfo") userInfo!: IStateUserInfo;
  @Getter("isPc") isPc!: boolean;
  @Getter("signalRConnected") signalRConnected: boolean;
  @Getter("tokenExpireTime") tokenExpireTime: number;

  @Action("handleOrderList")
  private actionHandleOrderList!: (payload: IOrderPayload) => Promise<any>;

  @Action("handleRefundOrderList")
  private actionHandleRefundOrderList!: (merchId: string) => Promise<any>;

  @Mutation("handleShowSelectMerchantModal")
  private handleShowSelectMerchantModal!: Function;

  @Mutation("handleOptions")
  private handleOptions!: Function;

  @Mutation("handleMerchId")
  private handleMerchId!: Function;

  @Mutation("handleUserInfo")
  private handleUserInfo!: Function;

  @Mutation("handleLoginMerchant")
  private handleLoginMerchant!: Function;

  @Mutation("handleMerchIds")
  private handleMerchIds!: Function;

  @Mutation("handleIsPc")
  private handleIsPc!: Function;

  @Mutation("handleUserLoginMerchants")
  private handleUserLoginMerchants!: Function;

  @Mutation("handleTabIndex")
  handleTabIndex!: Function;

  @Watch("options", { immediate: true, deep: true })
  onTokenChanged(newOptions: IWindowOptions, oldOptions: IWindowOptions) {
    if (newOptions.token) {
      sessionStorage.setItem("token", newOptions.token);
      commitTokenExpireTimeToVuex(newOptions.token);
    }
    switch (newOptions.eventType) {
      case EventType.WXApplicationDidBecomeActiveEvent:
        if (this.options.token && this.options.eventType && this.merchId) {
          this.$store.dispatch("cancelTimer");
          this.handleMerchId(this.merchId);
          this.handleLoginMerchant(this.$store.state.loginMerchant);
          this.handleShowSelectMerchantModal(false);
          let ExcludePreOrderStatuses: number[] = [];
          this.currentTab === "Processing"
            ? (ExcludePreOrderStatuses = [
                OrderStatus.Processing,
                OrderStatus.Ready,
                OrderStatus.Delivering
              ])
            : (ExcludePreOrderStatuses = []);
          this.actionHandleOrderList({
            page: this.$store.state.currentOrderPage,
            orderStatus: getOrderStatusForRequestOrderList(this.currentTab),
            keyword: this.$store.state.keyword,
            ExcludePreOrderStatuses
          });
          this.actionHandleRefundOrderList(this.merchId);
          this.setupHeartbeat();
        }
        break;
      case EventType.onBackPress:
        if (this.$route.name !== "Orders") {
          this.$router.replace({ name: "Home" });
          if (this.merchId) {
            this.actionHandleOrderList({
              page: 1,
              orderStatus: getOrderStatusForRequestOrderList("Processing"),
              keyword: this.$store.state.keyword,
              ExcludePreOrderStatuses: [
                OrderStatus.Processing,
                OrderStatus.Ready,
                OrderStatus.Delivering
              ]
            });
            this.actionHandleRefundOrderList(this.merchId);
          }
          this.handleTabIndex("Orders");
        }
        break;
      case EventType.Init:
        this.loadMerchantToLogin();
        break;
      case EventType.RefreshTokenSuccess:
        this.handleOptions(newOptions);
        break;
      case EventType.RefreshTokenError:
        this.handleOptions({
          token: "",
          refreshToken: "",
          eventType: "",
          oauthType: ""
        });
        this.$router.replace({ name: "Login" });
        break;
      case EventType.PC:
        this.handleOptions(newOptions);
        this.$router.replace({ name: "Orders" });
        break;
      case EventType.TakePhoto:
        // take photo
        break;
      case EventType.toOrderPage:
        if (newOptions.token && newOptions.merchId) {
          if (window.orderLoopPalySoundTimer) {
            clearInterval(window.orderLoopPalySoundTimer);
            window.orderLoopPalySoundTimer = null;
          }
          this.$store.dispatch("cancelTimer");
          this.handleMerchId(newOptions.merchId);
          this.getLoginMerchant(
            newOptions.stringLoginMerchantForReLogin as string
          );
          this.handleShowSelectMerchantModal(false);
          this.actionHandleOrderList({
            page: 1,
            orderStatus: getOrderStatusForRequestOrderList("Processing"),
            keyword: this.$store.state.keyword,
            ExcludePreOrderStatuses: [
              OrderStatus.Processing,
              OrderStatus.Ready,
              OrderStatus.Delivering
            ]
          });
          this.actionHandleRefundOrderList(this.merchId);
          this.setupHeartbeat();
          this.$router.replace({ name: "Orders" });
        }
        break;
    }
  }

  @Watch("merchId")
  onMerchIdChange() {
    if (this.token && this.merchId) {
      this.loadUnreadMessageCount();
    }
    this.runStartSignalR(() => {
      if (this.token && this.merchId && !this.isPc) {
        startSignalR(this.merchId, this.token);
      }
    });
  }

  merchIdsChangeTime: number = 0;

  @Watch("merchIds")
  async onMerchIdsChange(merchIds: string[]) {
    let now: number = new Date().getTime();
    if (now - this.merchIdsChangeTime > 3000) {
      this.merchIdsChangeTime = now;
      if (this.token && merchIds.length && this.isPc) {
        merchIds.forEach(x => {
          // this.loadUnreadMessageCount();
          startSignalR(x, this.token);
        });
      }
    }
    if (merchIds.length) {
      const { merches } = await merchBaseSetting(this.merchIds);
      let isAcceptPreOrder: boolean = merches.some((item: any) => {
        return item.acceptPreorder;
      });
      let orderCacheMinutes: number = merches.reduce(
        (maxCacheMinutes: number, currentItem: any) => {
          return currentItem.orderCacheMinutes > maxCacheMinutes
            ? (maxCacheMinutes = currentItem.orderCacheMinutes)
            : maxCacheMinutes;
        },
        0
      );
      this.$store.commit("handleAcceptPreOrder", isAcceptPreOrder);
      this.$store.commit("handleOrderCacheMinutes", orderCacheMinutes);

      if (!(this.$store.state.isPc || this.$store.state.openInBrowser)) {
        this.$store.commit("handleIsPrintEnable", merches[0].isPrintEnable);
      }
    }
  }

  @Watch("token")
  onTokenChange(newToken: string) {
    if (newToken && this.merchId) {
      commitTokenExpireTimeToVuex(newToken);
    }
    this.runStartSignalR(() => {
      if (newToken && this.merchId) {
        startSignalR(this.merchId, newToken);
      }
    });
  }

  @Watch("signalRConnected")
  onSignalRConnectionChanged() {
    if (!this.signalRConnected && this.merchId && this.token) {
      startSignalR(this.merchId, this.token);
      this.setupHeartbeat();
    }
  }

  time: number = 0;

  runStartSignalR(callback: Function) {
    let now: number = new Date().getTime();
    if (!this.signalRConnected && now - this.time > 1000) {
      this.time = now;
      callback ? callback() : "";
    }
  }

  public get showReConnectButton(): boolean {
    return this.$store.state.IM.showReConnectionButton;
  }

  public get token(): string {
    return this.options.token;
  }

  public get currentTab(): keyof IOrderStatusForRequestOrderList {
    return this.$store.state.currentOrderTab;
  }

  makeAlias() {
    let merchId = this.merchId.toLocaleUpperCase().replace(/-/g, ""),
      userId = this.userInfo.userId.toLocaleUpperCase().replace(/-/g, "");
    return `${merchId}:${userId}`;
  }

  async loadMerchantToLogin() {
    let signinToMerchantAppResponse = await merchSignin();
    this.merchants = signinToMerchantAppResponse.signedInMerchantInfos.map(
      x => {
        return {
          autoAcceptOrder: x.merchantAutoAcceptOrder,
          logo: x.merchantLogo,
          status: x.merchantStatus,
          merchAddress: x.merchantAddress,
          merchName: x.merchantName,
          merchId: x.userInfo.merchId,
          userId: x.userInfo.userId,
          userName: x.userInfo.displayName
        };
      }
    );
    this.handleUserLoginMerchants(this.merchants);
    // if (sessionStorage.getItem("isLogin")) {
    //   this.handleShowSelectMerchantModal(false);
    // } else {
    //   this.handleShowSelectMerchantModal(true);
    // }
    this.handleShowSelectMerchantModal(true);
  }

  onSelectMerchant(loginMerchant: ILoginMerchant) {
    let { merchId, userId, userName } = loginMerchant;
    if (merchId) {
      if (!this.$store.state.isPc) {
        this.$store.state.merchIds = [merchId];
      }
      this.$store.dispatch("cancelTimer");
      this.handleMerchId(merchId);
      this.handleLoginMerchant(loginMerchant);
      this.handleShowSelectMerchantModal(false);
      this.actionHandleOrderList({
        page: 1,
        orderStatus: getOrderStatusForRequestOrderList("Processing"),
        keyword: this.$store.state.keyword,
        ExcludePreOrderStatuses: [
          OrderStatus.Processing,
          OrderStatus.Ready,
          OrderStatus.Delivering
        ]
      });
      this.actionHandleRefundOrderList(this.merchId);
      this.actionHandleRefundOrderList(merchId);
      sendEvent("initNotification", merchId);
      sendEvent("onSelectedLoginMerchant", JSON.stringify(loginMerchant));
      const targetRouting = "Orders";
      if (this.$router.currentRoute.name !== targetRouting) {
        this.$router.replace({ name: targetRouting });
        this.$store.commit("handleTabIndex", 0);
      }
    }

    if (userId && userName) {
      this.handleUserInfo({ userId, userName });
    }

    // 解决网页刷新重新连接 signalR 问题
    if (
      this.token &&
      this.merchId &&
      this.$store.state.openInBrowser &&
      sessionStorage.getItem("isLogin")
    ) {
      startSignalR(this.merchId, this.token);
    }
  }

  async loadUnreadMessageCount() {
    const request: GetTotalUnReadCountRequest = {
      merchIds: [],
      orderIds: [],
      userIds: [],
      requestFrom: CommunicationParty.merchant
    };
    if (os().isPc) {
      request.merchIds = this.merchIds;
      getUnreadMessageCount(request);
      return;
    }
    this.$store.commit("handleMerchIds", [this.merchId]);
    getUnreadMessageCount(request);
  }

  mounted() {
    let isPc = os().isPc;
    this.handleIsPc(isPc);
    this.$store.commit(
      "handleOpenInBrowser",
      Boolean(sessionStorage.getItem("openInBrowser"))
    );
    if (this.isPc) {
      let urlParams = parseQueryToObject();
      let merchantsId = JSON.parse(urlParams.merchIds);
      if (Array.isArray(merchantsId) && merchantsId.length) {
        this.handleMerchIds(merchantsId);
        this.handleMerchId(merchantsId[0]);
      } else {
        this.handleMerchIds([]);
      }
      this.handleOptions({
        token: urlParams.token,
        refreshToken: "",
        eventType: "PC",
        oauthType: urlParams.tokenType,
        id: Math.random()
          .toString(36)
          .substring(2),
        meta: {
          imageSrc: ""
        }
      });
    } else {
      window.setOptions = (options: IWindowOptions) => {
        this.$store.commit("handleShowLoading", false);
        this.handleOptions({
          stringLoginMerchantForReLogin: options.stringLoginMerchantForReLogin
            ? options.stringLoginMerchantForReLogin
            : "",
          id: options.id,
          token:
            options.eventType === EventType.TakePhoto
              ? this.options.token
              : options.token,
          refreshToken:
            options.eventType === EventType.TakePhoto
              ? this.options.refreshToken
              : options.refreshToken,
          eventType: options.eventType,
          oauthType:
            options.eventType === EventType.TakePhoto
              ? this.options.oauthType
              : options.oauthType,
          meta: options.meta,
          merchId: options.merchId ? options.merchId : ""
        });
      };
    }
  }

  setupHeartbeat() {
    if (!window.wsConnectionTimer && this.token) {
      window.wsConnectionTimer = setInterval(() => {
        // Reset the timer is signalR is back to connected state
        if (this.signalRConnected) {
          this.connectionRetryCount = 0;
          clearInterval(window.wsConnectionTimer);
          clearInterval(window.pollingTimer);
          window.wsConnectionTimer = null;
          window.pollingTimer = null;
          return;
        }
        // Start polling if the retry count has exceed the maxSignalRRetryCount
        if (
          // this.connectionRetryCount > this.maxSignalRRetryCount &&
          !window.pollingTimer
        ) {
          window.pollingTimer = setInterval(() => {
            if (this.merchId) {
              if (this.$store.state.currentOrderTab === "Processing") {
                this.actionHandleOrderList({
                  page: this.$store.state.currentOrderPage,
                  orderStatus: getOrderStatusForRequestOrderList("Processing"),
                  keyword: this.$store.state.keyword,
                  ExcludePreOrderStatuses: [
                    OrderStatus.Processing,
                    OrderStatus.Ready,
                    OrderStatus.Delivering
                  ]
                });
              } else {
                this.actionHandleOrderList({
                  page: this.$store.state.currentOrderPage,
                  orderStatus: getOrderStatusForRequestOrderList(
                    this.currentTab
                  ),
                  keyword: this.$store.state.keyword,
                  ExcludePreOrderStatuses: []
                });
              }

              this.actionHandleRefundOrderList(this.merchId);
            }
            this.loadUnreadMessageCount();
          }, 60000);
        }

        if (this.token && this.merchId) {
          startSignalR(this.merchId, this.token);
        }
        this.connectionRetryCount += 1;
      }, 120000);
    }
  }

  getLoginMerchant(stringLoginMerchantForReLogin: string) {
    try {
      this.handleLoginMerchant(JSON.parse(stringLoginMerchantForReLogin));
    } catch (error) {}
  }
}
